class SitePasswordDialog extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector("dialog");
    this.handleOpen = this.open.bind(this);
    this.handleClose = this.close.bind(this);

    document.querySelectorAll("[data-password-toggle]").forEach((btn) => {
      btn.addEventListener("click", this.handleOpen);
    });

    this.querySelectorAll("[data-password-close]").forEach((btn) => {
      btn.addEventListener("click", this.handleClose);
    });

    this.dialog.addEventListener("click", (e) => {
      if (e.target === this.dialog) this.close();
    });
  }

  disconnectedCallback() {
    document.querySelectorAll("[data-password-toggle]").forEach((btn) => {
      btn.removeEventListener("click", this.handleOpen);
    });

    this.querySelectorAll("[data-password-close]").forEach((btn) => {
      btn.removeEventListener("click", this.handleClose);
    });
  }

  open() {
    this.dialog.showModal();
  }

  close() {
    this.dialog.close();
  }
}

if (!customElements.get("site-password-dialog")) {
  customElements.define("site-password-dialog", SitePasswordDialog);
}
